import { MeasurementPoint } from '@core/models/installation.model';
import { sourceGroup } from './installation-card-set';

// The PV card judges a PV array's yield from its meter, so the forecast and the performance ratios
// follow the first active PV point that is bound to a device.
export function pvForecastPoint(points: MeasurementPoint[]): MeasurementPoint | null {
  return (
    points.find(
      point =>
        point.role === 'pv_production' &&
        point.state === 'active' &&
        point.binding?.source.kind === 'device_channel' &&
        point.binding.source.deviceId !== null,
    ) ?? null
  );
}

export function pvDeviceId(points: MeasurementPoint[]): string | null {
  const deviceId = pvForecastPoint(points)?.binding?.source.deviceId;
  return deviceId === undefined || deviceId === null ? null : String(deviceId);
}

// One point per heat pump channel the installation reads: an active point bound to a device channel
// in the heat pump context. The heat pump's energyflow series are shown under its binding.
export function heatpumpSources(points: MeasurementPoint[]): MeasurementPoint[] {
  const sources = new Map<string, MeasurementPoint>();
  for (const point of points) {
    const source = point.binding?.source;
    if (
      point.state === 'active' &&
      source?.kind === 'device_channel' &&
      source.contextType === 'heatpump' &&
      source.deviceId !== null &&
      !sources.has(sourceGroup(point))
    ) {
      sources.set(sourceGroup(point), point);
    }
  }
  return [...sources.values()];
}

export function heatpumpDeviceIds(points: MeasurementPoint[]): string[] {
  return [...new Set(heatpumpSources(points).map(point => String(point.binding?.source.deviceId)))];
}

// Every device whose energyflow the installation pages read.
export function energyflowDeviceIds(points: MeasurementPoint[]): string[] {
  const pv = pvDeviceId(points);
  return [...new Set([...(pv ? [pv] : []), ...heatpumpDeviceIds(points)])];
}
